import React, { useState, useEffect, useRef } from 'react';
import { loadWebcams, setActiveCamera, setRangeValues, setRangeSettings, setCameraInterval, setDateSelected, setWeatherData, setAddressData, setIsSliderPlayings, setIsSidebar} from '../../actions/webcamAction';
import getCams from '../api/cams'
import {MODIMAGEPATH} from '../api';
import { getCameraImages } from '../api/camArchive';
import TnWebCamGallery from './TnWebCamGallery';
import Slider from "react-slick";
import Map from "../Map";
import { useDispatch, useSelector } from 'react-redux';
import Language from './../../language/language.json';
import Flatpickr from "react-flatpickr";
import flatpickr_locale from "./../../../node_modules/flatpickr/dist/l10n/de";

import "flatpickr/dist/flatpickr.css";

function TnWebCam(props) {
    //console.log(props);
    const cameras = JSON.parse(props.cameras);
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);

    const webcam = useSelector((store)=>store.webcam);
    //const cams = useSelector((store)=>store.webcam.cams);
    const isMaximizeMap = useSelector((store)=>store.map.maximizeMap);

    var dynamic_styles = '';

    var {cams,
        images,
        isFade,
        activeCamera, 
        redDot,
        isSidebar,
        dateSelected} = webcam;
    

    const dispatch = useDispatch();

    //const [isFade, setIsFade] = useState(false);

    const MAX = 100;

    const setCameraByIndex = (index) => {
        let cameraArr = Object.keys(cams);
        if(index in cameraArr){
            dispatch(setActiveCamera(cameraArr[index]));
        }
    }

    
    //const cameraLogo = useRef({});

    

    useEffect(() => {

        document.documentElement.style.setProperty('--widget-color', props.color);
        document.documentElement.style.setProperty('--widget-color1', props.color+'00');
        document.documentElement.style.setProperty('--widget-color2', props.color+'40');
        document.documentElement.style.setProperty('--widget-color3', props.color+'80');

        if (Object.keys(cams).length === 0) {
            var camids = [];
            cameras.forEach((camera) => {
                // initialize all camera slider
                var camid = camera.id;
                dispatch(setRangeValues(0, camid));
                dispatch(setRangeSettings({ 'max': MAX, 'step': 1 }, camid));
                dispatch(setIsSliderPlayings(true, camid));
                dispatch(setCameraInterval(dispatch, 'daily', camid));
                dispatch(setDateSelected(dispatch, new Date(), camid));
                dispatch(setWeatherData(null, camid));
                dispatch(setAddressData(null, camid));
                camids.push(camid);
            });
            (async () => {
                var request = {
                    ids: camids.join(','),
                    lang:props.lang
                }
                await getCams(request).then((data) => {
                    if (typeof data.cams !== 'undefined') {
                        //attach link,text,title and other props in the camera object
                        var orderedCamera = {};
                        cameras.forEach((cam)=>{
                            if(cam.id in data.cams){
                                Object.keys(cam).forEach((key)=>{
                                    if(key !== 'id'){
                                        data.cams[cam.id][key] = cam[key]
                                        //backward compatibility for seolink, seotext, seotitle
                                        if(['seolink', 'seotext', 'seotitle'].includes(key)){
                                            data.cams[cam.id][key.replace('seo','')] = cam[key]    
                                        } 
                                    }
                                });
                                orderedCamera['ordered'+cam.id] = data.cams[cam.id];
                            }
                        });
                        dispatch(loadWebcams(orderedCamera));

                        if (Object.keys(orderedCamera).length > 0) {
                            Object.values(orderedCamera).forEach((item, key) => {
                                getCameraImages(dispatch, item);
                                if(key === 0 && activeCamera === null){ //make the first camera active
                                    dispatch(setActiveCamera(item.id));
                                }                
                            });
                        }
                    }
                });
            })();
        }
    }, [])

    /*
    useEffect(() => {
        if (Object.keys(cams).length > 0) {
            Object.values(cams).forEach((item, key) => {
                getCameraImages(dispatch, item.id);
                if(key === 0 && activeCamera === null){ //make the first camera active
                    dispatch(setActiveCamera(item.id));
                }                
            });
        }
    }, [cams])
    */
    
    
    //console.log('cams', cams);

    //console.log(flatpickr_locale);
    
    return (

        <div className='tn-webcam-component'>
            
                <h1 className='main-title'>{Language[props.lang].widgetTitle}</h1>
                <div ref={props.refMainWrap} className={'tn-webcam-main-wraper' + (isSidebar ? ' sidebar-active-wrap' : '')}>
                <div className='sidebar-overlay'></div>
                <div className={'tn-webcam-main'  + (isFade ? ' show-content' : '') + (isSidebar ? ' show-content sidebar-active' : '')}>
                    {isSidebar ? 
                    <div className='tn-webcam-sidebar'>
                        <div className='tn-webcam-zoom-sidebar' onClick={()=>{dispatch(setIsSidebar(!isSidebar)); props.handleResize(!isSidebar);}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32.12" height="31.678" viewBox="0 0 32.12 31.678" className='close_icon' >
                                <g id="Group_36" data-name="Group 36" transform="translate(-1840.971 -52.916)">
                                    <g id="Group_27" data-name="Group 27" transform="translate(3209.539 -1219.016) rotate(135)">
                                    <line id="Line_16" data-name="Line 16" y2="23.246" transform="translate(1867.115 66.832) rotate(180)" fill="none" stroke="#000" strokeWidth="3"/>
                                    <line id="Line_19" data-name="Line 19" x1="22.084" transform="translate(1868.278 45.911) rotate(180)" fill="none" stroke="#000" strokeWidth="3"/>
                                    </g>
                                    <g id="Group_2" data-name="Group 2" transform="translate(1873.674 81.89) rotate(135)">
                                    <line id="Line_9" data-name="Line 9" y2="23.246" transform="translate(2.325)" fill="none" stroke="#000" strokeWidth="3"/>
                                    <line id="Line_10" data-name="Line 10" y2="23.246" transform="translate(2.325)" fill="none" stroke="#000" strokeWidth="3"/>
                                    <line id="Line_11" data-name="Line 11" y2="23.246" transform="translate(2.325)" fill="none" stroke="#000" strokeWidth="3"/>
                                    <line id="Line_12" data-name="Line 12" y2="20.921" transform="translate(2.325)" fill="none" stroke="#000" strokeWidth="3"/>
                                    <line id="Line_13" data-name="Line 13" x1="22.084" transform="translate(1.162 20.921)" fill="none" stroke="#000" strokeWidth="3"/>
                                    <line id="Line_14" data-name="Line 14" x1="22.084" transform="translate(0 20.921)" fill="none" stroke="#000" strokeWidth="3"/>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div className='sidebar-inner'>
                            <div className='sidebar-logo'>
                                <a rel={activeCamera ? (cams['ordered'+activeCamera]?.nofollow ? 'nofollow' : 'follow') : 'follow'} target={'_blank'} href={activeCamera ? cams['ordered'+activeCamera]?.url : '#'}>
                                    <img src={activeCamera ? cams['ordered'+activeCamera]?.logo : ''} alt='logo'  />
                                </a>
                            </div>
                            <div className={'datepiker-map-wraper ' + (isMaximizeMap ? 'maximize' : 'minimize')}>
                                {!isMaximizeMap ?
                                <div className='date-picker'>
                                    <Flatpickr options={{
                                            locale: flatpickr_locale[props.lang], 
                                            inline: true, 
                                            maxDate: new Date(),
                                            onChange: function(selectedDates, dateStr, instance) {
                                                //console.log(selectedDates[0], dateStr, instance);
                                                dispatch(setDateSelected(dispatch, selectedDates[0], activeCamera));
                                            }   
                                            }} 
                                            value={dateSelected['cam'+activeCamera]}
                                    />
                                </div>
                                :<></>
                                }
                                <div className='map-marker'>
                                    <Map color={props.color} />
                                </div>
                            </div>    
                            <div className='sidebar-bottom'>
                                <div className='sidebar-social-nav-main'>
                                    <p>{Language[props.lang].shareLabel}</p>
                                    <div className="sidebar-social-nav">
                                        <a target="_blank" href={"https://www.facebook.com/sharer.php?u=" + cams['ordered'+activeCamera]?.url + "&t=" + cams['ordered'+activeCamera]?.name}>
                                            <img src={MODIMAGEPATH + "fb.png"} alt="" />
                                        </a>
                                        <a target="_blank" href={"https://pinterest.com/pin/create/button/?url=" + cams['ordered'+activeCamera]?.url + "&description=" + cams['ordered'+activeCamera]?.name + "&media=" + cams['ordered'+activeCamera]?.campicurl} >
                                            <img src={MODIMAGEPATH + "pintrest.png"} alt="" />
                                        </a>
                                        <a target="_blank" onClick={(e)=>{e.preventDefault();window.open('https://webcamwidget.fullmarketing.at/ecardjoom.php?id=' + cams['ordered'+activeCamera]?.id + '&lang=' + props?.lang ,'popup','width=460,height=500'); return false;}} href={"/"}>
                                            <img src={MODIMAGEPATH + "email.png"} alt="" />
                                        </a>
                                    </div>
                                </div>
                                <div className='sidebar-txt'>
                                    {props.copyrightlink ? 
                                        <a rel={props?.nofollow ? 'nofollow' : 'follow'} href={props.copyrightlink} alt={props.copyrighttitle} title={props.copyrighttitle} target="_blank">
                                            {props.copyrighttext}
                                        </a>
                                    :
                                        <>{props.copyrighttext}</>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>    
                    :<></>
                    }
                    <div className='tn-webcam-details-area'>
                    <div className='tn-webcam-slider'>
                        <div className='tn-webcam-slider-top'>
                        
                        <div className='tn-webcam-slider-top-lt'>
                            {!isSidebar ?
                            <div className='tn-webcam-logo'>
                                <a target={'_blank'} href={activeCamera ? cams['ordered'+activeCamera]?.url : '#'}>
                                    <img src={activeCamera ? cams['ordered'+activeCamera]?.logo : ''} alt='logo'  />
                                </a>
                            </div>  
                            :<></>
                            }                        
                        </div>
                        
                        <div className='tn-webcam-slider-top-rt'>
                            <div className="tn-webcam-live">
                            <span className={"tn-webcam-live-dot " + (redDot ? "red" : "grey")}></span>
                            <p className="tn-webcam-live-txt">live</p>
                            </div>
                            <div className='tn-webcam-zoom' onClick={()=>{dispatch(setIsSidebar(!isSidebar));props.handleResize(!isSidebar);}}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" className='zoom_icon'>
                            <g id="Group_7" data-name="Group 7" transform="translate(-1732.5 -15.5)" opacity="0.75">
                                <line id="Line_3" data-name="Line 3" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_15" data-name="Line 15" y2="20" transform="translate(1785.5 35.5) rotate(180)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_4" data-name="Line 4" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_16" data-name="Line 16" y2="20" transform="translate(1785.5 35.5) rotate(180)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_5" data-name="Line 5" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_17" data-name="Line 17" y2="20" transform="translate(1785.5 35.5) rotate(180)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_6" data-name="Line 6" y2="18" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_18" data-name="Line 18" y2="18" transform="translate(1785.5 35.5) rotate(180)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_7" data-name="Line 7" x1="19" transform="translate(1733.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_19" data-name="Line 19" x1="19" transform="translate(1786.5 17.5) rotate(180)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_8" data-name="Line 8" x1="19" transform="translate(1732.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_20" data-name="Line 20" x1="19" transform="translate(1787.5 17.5) rotate(180)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <g id="Group_1" data-name="Group 1">
                                <line id="Line_9" data-name="Line 9" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_10" data-name="Line 10" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_11" data-name="Line 11" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_12" data-name="Line 12" y2="18" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_13" data-name="Line 13" x1="19" transform="translate(1733.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_14" data-name="Line 14" x1="19" transform="translate(1732.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                </g>
                                <g id="Group_4" data-name="Group 4" transform="translate(3520 86) rotate(180)">
                                <line id="Line_9-2" data-name="Line 9" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_10-2" data-name="Line 10" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_11-2" data-name="Line 11" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_12-2" data-name="Line 12" y2="18" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_13-2" data-name="Line 13" x1="19" transform="translate(1733.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_14-2" data-name="Line 14" x1="19" transform="translate(1732.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                </g>
                                <g id="Group_2" data-name="Group 2">
                                <line id="Line_9-3" data-name="Line 9" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_10-3" data-name="Line 10" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_11-3" data-name="Line 11" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_12-3" data-name="Line 12" y2="18" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_13-3" data-name="Line 13" x1="19" transform="translate(1733.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_14-3" data-name="Line 14" x1="19" transform="translate(1732.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                </g>
                                <g id="Group_5" data-name="Group 5" transform="translate(3520 86) rotate(180)">
                                <line id="Line_9-4" data-name="Line 9" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_10-4" data-name="Line 10" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_11-4" data-name="Line 11" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_12-4" data-name="Line 12" y2="18" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_13-4" data-name="Line 13" x1="19" transform="translate(1733.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_14-4" data-name="Line 14" x1="19" transform="translate(1732.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                </g>
                                <g id="Group_3" data-name="Group 3" transform="translate(1717 1803) rotate(-90)">
                                <line id="Line_9-5" data-name="Line 9" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_10-5" data-name="Line 10" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_11-5" data-name="Line 11" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_12-5" data-name="Line 12" y2="18" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_13-5" data-name="Line 13" x1="19" transform="translate(1733.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_14-5" data-name="Line 14" x1="19" transform="translate(1732.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                </g>
                                <g id="Group_6" data-name="Group 6" transform="translate(1803 -1717) rotate(90)">
                                <line id="Line_9-6" data-name="Line 9" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_10-6" data-name="Line 10" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_11-6" data-name="Line 11" y2="20" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_12-6" data-name="Line 12" y2="18" transform="translate(1734.5 50.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_13-6" data-name="Line 13" x1="19" transform="translate(1733.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                <line id="Line_14-6" data-name="Line 14" x1="19" transform="translate(1732.5 68.5)" fill="none" stroke="#fff" strokeWidth="3"/>
                                </g>
                            </g>
                                </svg>

                                <svg xmlns="http://www.w3.org/2000/svg" width="32.12" height="31.678" viewBox="0 0 32.12 31.678" className='close_icon' >
                                    <g id="Group_36" data-name="Group 36" transform="translate(-1840.971 -52.916)">
                                        <g id="Group_27" data-name="Group 27" transform="translate(3209.539 -1219.016) rotate(135)">
                                        <line id="Line_16" data-name="Line 16" y2="23.246" transform="translate(1867.115 66.832) rotate(180)" fill="none" stroke="#fff" strokeWidth="3"/>
                                        <line id="Line_19" data-name="Line 19" x1="22.084" transform="translate(1868.278 45.911) rotate(180)" fill="none" stroke="#fff" strokeWidth="3"/>
                                        </g>
                                        <g id="Group_2" data-name="Group 2" transform="translate(1873.674 81.89) rotate(135)">
                                        <line id="Line_9" data-name="Line 9" y2="23.246" transform="translate(2.325)" fill="none" stroke="#fff" strokeWidth="3"/>
                                        <line id="Line_10" data-name="Line 10" y2="23.246" transform="translate(2.325)" fill="none" stroke="#fff" strokeWidth="3"/>
                                        <line id="Line_11" data-name="Line 11" y2="23.246" transform="translate(2.325)" fill="none" stroke="#fff" strokeWidth="3"/>
                                        <line id="Line_12" data-name="Line 12" y2="20.921" transform="translate(2.325)" fill="none" stroke="#fff" strokeWidth="3"/>
                                        <line id="Line_13" data-name="Line 13" x1="22.084" transform="translate(1.162 20.921)" fill="none" stroke="#fff" strokeWidth="3"/>
                                        <line id="Line_14" data-name="Line 14" x1="22.084" transform="translate(0 20.921)" fill="none" stroke="#fff" strokeWidth="3"/>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>

                        </div>
                        <div className='tn-webcam-slider-middle'>
        {Object.keys(images).length === Object.keys(cams).length ?
            <>
                <Slider
                    asNavFor={Object.keys(cams).length > 1 ? nav2 : null}
                    fade={true}
                    speed={1000}
                    ref={slider => (setNav1(slider))}
                    draggable={false}
                    
                >
                    {
                        
                        Object.keys(cams)?.map((value, key) => {
                                let item = value.replace('ordered','');  
                                if(cams[value].image_position || cams[value].transform_scale){
                                    dynamic_styles += 'tn-webcam-widget > div .tn-webcam-slider-middle > .slick-slider:first-child .cam'+item+' .image-gallery-content .image-gallery-slide .image-gallery-image {';
                                        if(cams[value].image_position)
                                        dynamic_styles += 'object-position: '+cams[value].image_position+'; -o-object-position: '+cams[value].image_position+'; transform-origin: '+cams[value].image_position+';';

                                        if(cams[value].transform_scale)
                                        dynamic_styles += 'transform: scale('+cams[value].transform_scale+');';
                                    dynamic_styles += '} ';
                                }
                                                              
                                return(
                                    ('cam'+item in images) ? 
                                    <div key={"a"+item} className={"cam"+item}>
                                        <TnWebCamGallery camid={item} lang={props.lang} accomodation={props.accomodation} 
                                                                copyrightlink={props.copyrightlink}
                                                                copyrighttext={props.copyrighttext}
                                                                copyrighttitle={props.copyrighttitle}
                                                                nofollow={props?.nofollow} />                                        
                                    </div>
                                    : <div key={"a" + item}>{Language[props.lang].loading}</div>
                            )

                        })
                    }
                </Slider>
                <style dangerouslySetInnerHTML={{__html: dynamic_styles}} /> 

                {Object.keys(cams).length > 1 ?  //only show thumbnai if there are more than one camera. 
                <Slider
                    asNavFor={nav1}
                    ref={slider => (setNav2(slider))}
                    slidesToShow={2}
                    swipeToSlide={true}
                    focusOnSelect={true}
                    className='thumbnail-slider'
                    beforeChange={ (oldIndex,newIndex) => {
                            setCameraByIndex(newIndex);
                        }
                    }
                    >
                    {
                        Object.keys(images).length === Object.keys(cams).length && Object.keys(cams)?.map((item, key) => {
                                item = item.replace('ordered','');
                                return(
                                    ('cam'+item in images) ? 
                                    <div key={"a"+item}>
                                        <img alt={''} src={images['cam'+item]?.slice(-1)[0]?.thumbnail} /> 
                                    </div>
                                    : <div key={"a" + item}>
                                        <h1>{key}</h1>
                                    </div>
                            )

                        })
                    }
                </Slider>
                : <></>
                }
            </>            
            :
            <>
                <p>{Language[props.lang].loading}....</p>
            </>
        }
            </div>
                       

                    </div>
                    </div>
                </div>
                </div>
            </div> 
             
    )
}

export default TnWebCam;
